export const MODULE = 'MISCELLANEOUS_FEE_APPLICATION';

export const GET_TRANSACTION = `${MODULE}/get_transaction`;
export const SHOW_TRANSACTION = `${MODULE}/show_transaction`;
export const ASSESS_RECEIPT = `${MODULE}/assess_receipt`;

export const MISCELLANEOUS_FEE_EOR_URL =
  'api/v1/administrators/transaction_histories/miscellaneous_fee_payments/{id}/preview_or';
